// extracted by mini-css-extract-plugin
module.exports = {"history_data_wrapper":"HistoryData_history_data_wrapper__1HdTA"};